<app-form (onsubmit)="submit()">
  <div class="max-w-2xl mx-auto space-y-4">
    <app-alert variant="notice">By submitting, you agree to all charges above.</app-alert>

    <div>
      <app-signature-pad [required]="true" [disabled]="disabled()" name="signature" label="Signature" (signatureChange)="signature.set($event)"/>
    </div>

    <div class="text-center">
      <app-button type="submit" [disabled]="buttonDisabled()">Submit</app-button>
    </div>
  </div>
</app-form>
